import { TraitConnectionsControls } from "./TraitConnectionsControls";

export function TraitConnectionsPanel() {
    return <TraitConnectionsControls />;
}
